export const HOUR_OPTIONS = [
  { value: '' as const, label: '---' },
  ...Array.from({ length: 24 }, (_, i) => ({ value: i, label: String(i).padStart(2, '0') })),
];

export const MINUTE_OPTIONS = [
  { value: '' as const, label: '---' },
  ...Array.from({ length: 60 }, (_, i) => ({ value: i, label: String(i).padStart(2, '0') })),
];
